import { BaseFieldView } from '../BaseField/views';

export const InstructionsFieldView = BaseFieldView.extend({});
